module.exports = __webpack_public_path__ + "img/icon-chahua.c1aa9865.png";